function enable(id) {
    var eleman = document.getElementById(id);
    eleman.removeAttribute("disabled");
    var elemanSpan = document.getElementById("span" + id);
    elemanSpan.style.display = "block";
}


export function pre1981options() {
    enable("cMake");
    enable("cYear");   
}